import React, {useState, useEffect} from 'react';
import {Alert, Col} from 'react-bootstrap';
import {useParams} from 'react-router-dom';

import axios from 'axios';
import {apiUrl} from '../../util/Api';

const CancelReset = () => {
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);

  let {resetToken} = useParams();

  useEffect(()=>{

    let options = {
      /*email: email,
      resetKey: resetKey,*/
      token: resetToken
    }

    axios.post(apiUrl + '/recover/cancel', options, {withCredentials: true})
    .then((res) => {
      if(res.data.status === "ok") {
        setSuccess(true)
      } else {
        let errorMsgs = [];
        res.data.errors.forEach((error, i) => {
          switch (error) {
            case 'token-missing':
              errorMsgs.push('The recovery token was missing.');
              break;
            case 'token-expired':
              errorMsgs.push('The recovery token expired.');
              break;
            case 'invalid-token':
              errorMsgs.push('The recovery token is invalid.');
              break;
            case 'no-recovery':
              errorMsgs.push('The was no matching recovery request.');
              errorMsgs.push('The request may have already been used or cancelled.');
              break;
            default:
              errorMsgs.push('There was an error processing this request.');
          }
        });
        setErrors(errorMsgs);
      }
    }).catch((err) => {
      //console.log('something went wrong');
      setErrors(['An error occurred.']);
    });
  },[resetToken])


  //check if logged in
  return (
    <Col xs={10} sm={8} md={6} className="public-component">
      <h3>Cancel Reset Request</h3>

      {
        errors.length > 0 ? (
          <Alert variant='danger'>
          {errors.map((err, i) => (<div key={'err.' + i}>{err}</div>))}
          </Alert>
        ) : (null)
      }

      {success ? (
        <Alert variant='info'>
          The reset request was successfully cancelled.
        </Alert>
      ) : (null)}

    </Col>
  );
}


export default CancelReset;
